import { useMemo } from 'react'
import { ALL_TOOL_NAMES } from '../../server/lib/tools'

interface ToolSelectorProps {
  selectedTools: string[]
  onChange: (tools: string[]) => void
}

export function ToolSelector({ selectedTools, onChange }: ToolSelectorProps) {
  const availableTools = useMemo(() => {
    return ALL_TOOL_NAMES.filter((tool) => !selectedTools.includes(tool))
  }, [selectedTools])

  const handleToolClick = (toolName: string, isSelected: boolean) => {
    if (isSelected) {
      // Move to available (remove from selected)
      onChange(selectedTools.filter((t) => t !== toolName))
    } else {
      // Move to selected (add to selected)
      onChange([...selectedTools, toolName])
    }
  }

  const handleSelectAll = () => {
    onChange([...ALL_TOOL_NAMES])
  }

  const handleClear = () => {
    onChange([])
  }

  return (
    <div className="tool-selector">
      <div className="tool-selector__column">
        <div className="tool-selector__header">
          <h3 className="tool-selector__heading">Available</h3>
          <button
            type="button"
            className="tool-selector__action"
            onClick={handleSelectAll}
            disabled={availableTools.length === 0}
            title="Add all tools"
          >
            All
          </button>
        </div>
        <div className="tool-selector__tools">
          {availableTools.map((tool) => (
            <button
              key={tool}
              type="button"
              className="tool-selector__tool tool-selector__tool--available"
              onClick={() => handleToolClick(tool, false)}
              title="Click to add to selected tools"
            >
              {tool}
            </button>
          ))}
        </div>
      </div>

      <div className="tool-selector__column">
        <div className="tool-selector__header">
          <h3 className="tool-selector__heading">Tools</h3>
          <button
            type="button"
            className="tool-selector__action"
            onClick={handleClear}
            disabled={selectedTools.length === 0}
            title="Clear all tools"
          >
            Clear
          </button>
        </div>
        <div className="tool-selector__tools">
          {selectedTools.length > 0 ? (
            selectedTools.map((tool) => (
              <button
                key={tool}
                type="button"
                className="tool-selector__tool tool-selector__tool--selected"
                onClick={() => handleToolClick(tool, true)}
                title="Click to remove from selected tools"
              >
                {tool}
              </button>
            ))
          ) : (
            <p className="tool-selector__empty">No tools selected</p>
          )}
        </div>
      </div>
    </div>
  )
}
